// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/earth.js';

import { paths } from '../generated/earth';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('earth', Original, paths);
